export const PRIVATE_LOGIN_STATE = {
  NOT_LOGGED_IN: 'not_logged_in',
  LOGGED_IN_STORAGE_ACCESS_REQUIRED: 'logged_in_storage_access_required',
  STORAGE_ACCESS_GRANTED_LOGIN_UNCONFIRMED: 'storage_access_granted_login_unconfirmed',
  ALL_ACCESS_ATTEMPTS_FAILED: 'all_access_attempts_failed',
  LOGGED_IN_NOT_OWNER: 'logged_in_not_owner',
};

export type Enum<T> = T[keyof T];

export type PrivateLoginStateType = Enum<typeof PRIVATE_LOGIN_STATE>;
